// @flow
import {
  // $FlowFixMe
  useEffect,
  // $FlowFixMe
  useState
} from "react";

type Props = {
  value: number | string,
  duration?: number
};

const easeOutQuad = (t) => t * (2 - t);
const frameDuration = 1000 / 60;

const CountUpAnimation = ({ value, duration = 1000 }: Props) => {
  const countTo = parseInt(value, 10);
  const [count, setCount] = useState(0);

  useEffect(() => {
    let frame = 0;
    const totalFrames = Math.round(duration / frameDuration);
    const counter = setInterval(() => {
      frame += 1;
      const progress = easeOutQuad(frame / totalFrames);
      setCount(countTo * progress);

      if (frame === totalFrames) {
        clearInterval(counter);
      }
    }, frameDuration);
  }, []);

  return Math.floor(count);
};

export default CountUpAnimation;
